/** Error names the host gives to remote failures, filterable in Datadog as `error.kind`. */
export const MFE_ERROR_NAMES = {
  DISABLED: 'MfeRemoteDisabledError',
  NOT_ALLOWED: 'MfeRemoteNotAllowedError',
  TIMEOUT: 'MfeRemoteTimeoutError',
} as const;

export type MfeErrorName = typeof MFE_ERROR_NAMES[keyof typeof MFE_ERROR_NAMES];

/** Creates an Error whose `name` identifies the kind of remote failure. */
export const createMfeError = (name: MfeErrorName, message: string): Error => {
  const error = new Error(message);
  error.name = name;
  return error;
};

/** Normalizes anything thrown into an Error. */
export const toError = (error: unknown): Error => (error instanceof Error ? error : new Error(String(error)));

/** Error kind for logs: the custom name when set, the constructor name otherwise. */
export const errorKind = (error: unknown): string =>
  error instanceof Error ? error.name || error.constructor.name : 'Unknown';

/**
 * Whether trying again can succeed. A remote that is disabled or not allowed for this environment
 * fails the same way on every attempt, so offering a retry would only frustrate the user.
 */
export const isRetryableRemoteError = (error: unknown): boolean =>
  !(error instanceof Error) || (error.name !== MFE_ERROR_NAMES.DISABLED && error.name !== MFE_ERROR_NAMES.NOT_ALLOWED);
